import React from "react";
import { Box, Divider } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const PaymentPlanSharedComponentSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <CustomCard
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.PaymentPlanSharedComponent}
    >
      <Box className={styles.containerHeader}>
        <Skeleton variant="text" width={80} height={25} />
        <Divider />
      </Box>
      <Box className={styles.containerBody}>
        {[...Array(4)].map((_, index) => (
          <Box key={index} className={styles.rowLayout}>
            <Box className={styles.containerLeftSide}>
              <Skeleton variant="text" width={80} height={25} />
              <Skeleton variant="text" width={80} height={25} />
            </Box>
            <Skeleton variant="text" width={80} height={25} />
          </Box>
        ))}
      </Box>
    </CustomCard>
  );
};
export default PaymentPlanSharedComponentSkeleton;
